import { styled } from '@mui/material/styles'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'
import Helmet from 'react-helmet'
import { Grid, Image } from 'semantic-ui-react'
import { CheckList } from 'components/check_list'
import { IframeLoader } from 'components/iframe_loader'
import { Layout } from 'components/layout'
import { Section } from 'components/section'
import { StepCatchText } from 'components/step_catch_text'
import { Wrapper } from 'components/wrapper'
import LinedBanner from 'images/wp_line_basic_banner.png'

const MainImage = styled(Image)(({ theme }) => ({
  width: '100%',
  height: 'auto',
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    height: '400px',
  },
}))

const WhitepaperPage = (props) => (
  <Layout>
    <Helmet
      title="LINEキャンペーン設計ガイド - お役立ち資料｜ギフティ - キャンペーンに効果的な法人向けデジタルギフト"
      meta={[
        {
          name: 'description',
          content:
            ' LINEキャンペーンを実施する際に、設計にあたって押さえておくべき考え方やポイントをまとめしました。各SNSの比較表やLINEのサービス特徴など、関連する情報も網羅しており、基本的な情報をご確認いただけます。ぜひお手元でご覧ください。',
        },
        {
          name: 'keywords',
          content: 'LINE,デジタルギフト,キャンペーン,友だち獲得,ブロック防止',
        },
        {
          property: 'og:title',
          content:
            'LINEキャンペーン設計ガイド - お役立ち資料｜ギフティ - キャンペーンに効果的な法人向けデジタルギフト',
        },
        {
          property: 'og:description',
          content:
            'LINEキャンペーンを実施する際に、設計にあたって押さえておくべき考え方やポイントをまとめました。各SNSの比較表やLINEのサービス特徴など、関連する情報も網羅しており、基本的な情報をご確認いただけます。ぜひお手元でご覧ください。',
        },
        {
          property: 'og:image',
          content:
            'https://giftee.biz/assets/images/ogps/ogp-wp-line-basic.png',
        },
      ]}
    />

    <Section backgroundColor="" centered>
      <Grid.Column mobile={16} tablet={16} computer={16} verticalAlign="middle">
        <MainImage
          src={LinedBanner}
          alt="LINEキャンペーンに特化したホワイトペーパーのご紹介！"
          centered
          rounded
        />
      </Grid.Column>
    </Section>
    <Section centered noPaddingTop noPaddingBottom>
      <Grid.Row>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <StepCatchText>
            LINEキャンペーンに特化したホワイトペーパーのご紹介！
          </StepCatchText>
          <Wrapper molecule>
            <p>
              LINEキャンペーンを実施する際に、設計にあたって押さえておくべき考え方や必ず対策しなくてはならはならないポイントを本資料でおまとめしました。さらに、各SNSの比較表やLINEのサービス特徴など、関連する情報も網羅しており、基本的な情報を全てご確認いただけます。ぜひお手元でご覧ください。
            </p>
          </Wrapper>
        </Grid.Column>
      </Grid.Row>
    </Section>

    <Section noPaddingTop>
      <Grid.Column mobile={16} tablet={16} computer={8}>
        <Img fluid={props.data.DocumentImage.childImageSharp.fluid} />
        <Section centered paddingSize="12px" />
        <Grid.Column>
          <CheckList>
            <li>各SNSにおける特徴の比較表</li>
            <li>LINEの特徴</li>

            <li>LINEマーケティングと設計時の3大ポイント</li>
            <li>gifteeが提供するLINEソリューションのご紹介</li>
          </CheckList>
        </Grid.Column>
      </Grid.Column>

      <Grid.Column mobile={16} tablet={16} computer={8}>
        <IframeLoader
          src="https://go.giftee.biz/l/640953/2020-08-12/4zwx9"
          title="問い合わせフォーム"
          width="100%"
          height="1850"
        />
      </Grid.Column>
    </Section>
  </Layout>
)

export default WhitepaperPage

export const pageQuery = graphql`
  query {
    DocumentImage: file(relativePath: { eq: "wp_line_basic_image.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
